import { render, staticRenderFns } from "./SubmitButtonWithMessages.vue?vue&type=template&id=1ce51d72&scoped=true"
import script from "./SubmitButtonWithMessages.vue?vue&type=script&lang=ts"
export * from "./SubmitButtonWithMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce51d72",
  null
  
)

export default component.exports